module.exports = __webpack_public_path__ + "img/products-md@2x.a122e47a.png";